import { useCallback } from 'react';
import Card, { ContentCard } from '@ingka/card';
import type { LotteryTemplate as LotteryTemplateType } from '@lotta/shared/types-lottery-schemas';
import { useNavigateWithLocale } from '@lotta/self-service/lottery-fe/feature-hooks';
import styles from './LotteryTemplate.module.scss';

type LotteryTemplateProps = {
  lotteryTemplate: LotteryTemplateType;
};

export const LotteryTemplate: React.FC<LotteryTemplateProps> = ({
  lotteryTemplate: { id, title, description },
}) => {
  const navigate = useNavigateWithLocale();

  const handleCreateForm = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      e.preventDefault();
      navigate(`/create/${id}`);
    },
    [navigate, id]
  );

  return (
    <div
      className={styles['container']}
      onClick={handleCreateForm}
      data-testid={`template-card-${id}`}
    >
      <div className={styles['card-container']}>
        <Card
          className={styles['card']}
          content={
            <ContentCard
              title={title}
              id={id}
              body={description}
              titleHeadingTag={'h2'}
              fixed={true}
              buttonType="primary"
            />
          }
        />
      </div>
    </div>
  );
};
